/**
 * @generated SignedSource<<b8281975f085b7b4e4c20e620dddb19c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportResolution_report$data = {
  readonly id: string;
  readonly reviewStatus: string | null;
  readonly pendingResolutions: {
    readonly totalCount: number;
  };
  readonly anomalyCounts: ReadonlyArray<{
    readonly type: string | null;
    readonly count: number | null;
  } | null> | null;
  readonly " $fragmentType": "ReportResolution_report";
};
export type ReportResolution_report$key = {
  readonly " $data"?: ReportResolution_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportResolution_report">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ReportResolutionRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "ReportResolution_report",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviewStatus",
      "storageKey": null
    },
    {
      "alias": "pendingResolutions",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "updateStatus": "pending"
          }
        }
      ],
      "concreteType": "ReportResolutionsConnection",
      "kind": "LinkedField",
      "name": "reportResolutions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnomalyCount",
      "kind": "LinkedField",
      "name": "anomalyCounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Report",
  "abstractKey": null
};

(node as any).hash = "a89f316b391956c6a2a3694859fed56a";

export default node;
